import { useNavigate } from "react-router-dom";
import { FileQuestion } from "lucide-react";
import { Button } from "../components/ui/Button";
import { useAuth } from "../hooks/useAuth";

export default function NotFoundPage() {
  const navigate = useNavigate();
  const { user, isAdmin } = useAuth();

  const handleGoToDashboard = () => {
    if (!user) navigate("/login");
    else if (isAdmin) navigate("/admin/dashboard");
    else navigate("/employee/dashboard");
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#f8fafc] p-4">
      <div className="flex flex-col items-center gap-6 text-center max-w-sm">
        <div className="flex h-16 w-16 items-center justify-center rounded-full bg-[#eff6ff]">
          <FileQuestion className="h-8 w-8 text-[#2447d9]" />
        </div>
        <div>
          <p className="text-5xl font-extrabold text-[#2447d9] mb-3">404</p>
          <h1 className="text-xl font-bold text-[#0f172a]">Page Not Found</h1>
          <p className="mt-2 text-sm text-[#64748b]">
            The page you're looking for doesn't exist or has been moved.
          </p>
        </div>
        <Button onClick={handleGoToDashboard}>
          Go to Dashboard
        </Button>
      </div>
    </div>
  );
}
